// removed by extract-text-webpack-plugin
module.exports = {"section":"_1ubN","pattern":"_2fXW","inner":"_1UOR","fullHeight":"_2jPb"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Section/Section.scss
// module id = QOyu
// module chunks = 0